import styled from "styled-components";
import theme from "../../theme/theme";

const Wrapper = styled.div`
  background-color: ${theme.colors.white};
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  height: fit-content;
`;

const Card = ({ children, className }) => {
  return <Wrapper className={className}>{children}</Wrapper>;
};

export default Card;
